import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useExpensesStore } from '../../store/expensesStore'
import { createExpense } from '../../utils/createExpense'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useAddExpenseMutation = (onSuccess?: () => void) => {
  const addExpense = useExpensesStore((state) => state.addExpense)

  return useMutation({
    mutationFn: createExpense,
    onSuccess: ({ message, expense }) => {
      addExpense(expense)
      toast.success(message || 'Expense created successfully.')
      onSuccess?.()
    },
    onError: (error: ApiError) => {
      notifyRequestError(error, 'Failed to submit your expense request. Please try again.')
    },
  })
}
